import React, {useEffect} from 'react';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import {fade, makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import SearchIcon from '@material-ui/icons/Search';
import AccountCircle from '@material-ui/icons/AccountCircle';
import SaveIcon from '@material-ui/icons/Save';
import Badge from '@material-ui/core/Badge';
import Checkbox from '@material-ui/core/Checkbox';

const firebaseConfig = {
  apiKey: 'AIzaSyDND4gzXlNR6NUu7jyMXxE-jYjdGutvxGg',
  authDomain: 'rotmg-drop-counter.firebaseapp.com',
  databaseURL: 'https://rotmg-drop-counter.firebaseio.com',
  projectId: 'rotmg-drop-counter',
  storageBucket: 'rotmg-drop-counter.appspot.com',
  messagingSenderId: '605268520184',
  appId: '1:605268520184:web:61d61309f62f10551b5f0d',
  measurementId: 'G-JSYDCLRJ1H',
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const provider = new firebase.auth.GoogleAuthProvider();

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: 'none',
    cursor: 'arrow',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  labelGroup: {
    display: 'table',
    float: 'left',
    marginRight: '5px',
  },
  label: {
    display: 'table-row',
    textAlign: 'center',
  },
  chk: {
    marginTop: '-10px',
  },
}));

export default ({
  size,
  user,
  callback,
  search,
  total,
  setSendSave,
  toggles,
  setToggles,
}) => {
  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => callback(user));
  }, [callback]);

  const login = () => {
    firebase.auth().signInWithPopup(provider);
  };
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleChange = (event) => {
    setToggles({
      ...toggles,
      [event.target.name]: (toggles[event.target.name] + 1) % 3,
    });
  };
  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.grow}>
      <AppBar>
        <Toolbar>
          <Badge color="secondary" badgeContent={total} max={999}>
            <div>
              {size.width > 602 && (
                <section>
                  <img
                    className="top"
                    src={process.env.PUBLIC_URL + '/25.png'}
                    alt="logo1"
                  />
                  <img
                    className="bot"
                    src={process.env.PUBLIC_URL + '/26.png'}
                    alt="logo2"
                  />
                </section>
              )}
            </div>

            <Typography
              style={{cursor: 'pointer', letterSpacing: '8px'}}
              className={classes.title}
              variant="h5"
              noWrap
            >
              DROPS
            </Typography>
          </Badge>

          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Search..."
              onChange={(e) => search(e.target.value)}
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{'aria-label': 'search'}}
            />
          </div>
          <div>
            <div className={classes.labelGroup}>
              <label className={classes.label}>GOT</label>
              <Checkbox
                name="got"
                className={classes.chk}
                checked={toggles.got !== 0}
                indeterminate={toggles.got === 2}
                onChange={handleChange}
                size="small"
                inputProps={{'aria-label': 'primary checkbox'}}
              />
            </div>
            <div className={classes.labelGroup}>
              <label className={classes.label}>
                <span className={classes.strikediag}>SB</span>
              </label>
              <Checkbox
                name="sb"
                className={classes.chk}
                checked={toggles.sb !== 0}
                indeterminate={toggles.sb === 2}
                onChange={handleChange}
                size="small"
                inputProps={{'aria-label': 'primary checkbox'}}
              />
            </div>
            <div className={classes.labelGroup}>
              <label className={classes.label}>TIER</label>
              <Checkbox
                name="tier"
                className={classes.chk}
                checked={toggles.tier !== 0}
                indeterminate={toggles.tier === 2}
                onChange={handleChange}
                size="small"
                inputProps={{'aria-label': 'primary checkbox'}}
              />
            </div>
          </div>

          <div className={classes.grow} />

          <div>
            {user && (
              <IconButton
                edge="end"
                aria-haspopup="true"
                onClick={() => setSendSave(true)}
                color="inherit"
              >
                <SaveIcon />
              </IconButton>
            )}

            <IconButton
              edge="end"
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{vertical: 'top', horizontal: 'right'}}
        transformOrigin={{vertical: 'top', horizontal: 'right'}}
        keepMounted
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        {user && (
          <MenuItem onClick={handleMenuClose}>{user.displayName}</MenuItem>
        )}
        {user && (
          <MenuItem
            onClick={() => {
              firebase.auth().signOut();
              handleMenuClose();
            }}
          >
            SIGN OUT
          </MenuItem>
        )}
        {!user && (
          <MenuItem
            onClick={() => {
              login();
              handleMenuClose();
            }}
          >
            LOG IN
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};
